<template>
<section class="my-5">
      <div class="container">
        <div class="row gy-4 align-items-center">
          <div class="col-12 col-md-6">
            <h1 class="fw-bold">Salut, je suis <b class="fw-bold">Fatou NIANG</b> Élève ingénieure en informatique.</h1>
            <p class="text">
              Je suis passionnée de développement web et mobile et tous ce qui est touche la création
              de logiciels et l'analyse de données.
              De nature autonome et organisée, ma curiosité me pousse à vouloir enrichir davantage mes compétences.
            </p>
          </div>
          <div class="col-12 col-md-6">
            <img src="../assets/IMG_4637.png" alt="Fatou NIANG" width="40%" class="rounded-3 shadow">
          </div>
        </div>
      </div>
    </section>

</template>
<script>

export default ({
   name:'HomeView'
})
</script>
<style scoped>
.text{
  text-align: justify;
  text-indent: 3px;
}
</style>